module.exports = __webpack_public_path__ + "b32acea6fd3c228b5059042c7ad21c55.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/clarity-ui/dist/fonts/open-sans-semibold.ttf
// module id = 1547
// module chunks = 0